import { render, staticRenderFns } from "./SubjectEnrollmentDetails.vue?vue&type=template&id=2fec052d&"
import script from "./SubjectEnrollmentDetails.vue?vue&type=script&lang=js&"
export * from "./SubjectEnrollmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports